import styled from 'styled-components';

export const Card = styled.div`
  background-color: #FFFFFF;
  padding: 16px 16px 0px 16px;
  border: 1px solid #F0F0F0;
`;
